import FeatureGates from '@atlaskit/feature-gate-js-client';
import { addParamsToUrl } from '../history-qs';
import type { ArticleSource } from './types';

// Used for Analytics Call.
export const addSourceToUrl = (url: string, source: ArticleSource, isExternalResource: boolean = false): string => {
    if (isExternalResource || !FeatureGates.checkGate('jsm_kb_source_value_in_query_param')) return url;
    return addParamsToUrl(url, { source });
};
